import React from 'react';
import { Title } from '../../atoms';
import { FaCamera } from 'react-icons/fa';

export const PrintProductList = ({
    productImage,
    productName,
    isImage,
    variantName
}) => {
    console.log("prod name", productName);
    return (
        <div>
            <div className="printAlign">
                {isImage ?
                    <div className="imgBorder">
                        <img src={productImage} alt="" className="printItemImg" />
                    </div>
                    :
                    <div className="emptyImage">
                        <FaCamera className={'menuIconCls'} color={'white'} size={17} />
                    </div>
                }
                <div style={{display: 'flex', flexDirection: 'column'}}>
                <Title text={productName} className="printProductCls" />
                <Title text={variantName} className="printVariantCls"/>
                </div>
            </div>
        </div>
    )
}
